import { render, staticRenderFns } from "./ResidentialAccount.vue?vue&type=template&id=3ddaad58"
import script from "./ResidentialAccount.vue?vue&type=script&lang=js"
export * from "./ResidentialAccount.vue?vue&type=script&lang=js"
import style0 from "./ResidentialAccount.vue?vue&type=style&index=0&id=3ddaad58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports